import { PromotionSuiteVoucherStatus, VoucherInfo, VoucherReasonType } from '@/types';
import { extractDateParts } from '@/utils/date';
import { voucherService } from '../../services/voucher.service';

import { useReward } from '@/contexts/reward-context';
import { EventVoucherIcon } from '@/components/icons/event-voucher-icon';

const formatDate = (date: string | Date) => {
	const { year, month, day } = extractDateParts(date)	
	return `${year}.${month}.${day}`;
};

const promotionNameReasonTypes = new Set([
	VoucherReasonType.WCDailyLuckySpin,
	VoucherReasonType.WCWeeklyPrize,
	VoucherReasonType.FreeBetStreamer,
	VoucherReasonType.FreeBetCustomized,
	VoucherReasonType.Saba,
]);

export const VoucherRecordItem = ({ 
	voucher,
	isInObtainedTab 
}: { 
	voucher: VoucherInfo;
	isInObtainedTab: boolean;
}) => {
	const { labels } = useReward();

	const usedStatus = voucher.VoucherStatus
		?? (voucher.UseDate ? PromotionSuiteVoucherStatus.Used : PromotionSuiteVoucherStatus.Expired);
	const usedDate = usedStatus === PromotionSuiteVoucherStatus.Expired
		? voucher.ExpireDate
		: voucher.UseDate || voucher.ExpireDate;
	const displayDate = isInObtainedTab ? voucher.TransactionDate : usedDate;

	const usedStatusLabelMap: Record<number, string | undefined> = {
		[PromotionSuiteVoucherStatus.Used]: labels?.lbl_RPUtilizedVoucher,
		[PromotionSuiteVoucherStatus.Expired]: labels?.lbl_RPVoucherExpired,
		[PromotionSuiteVoucherStatus.Recalled]: labels?.lbl_RPVoucherCancelled,
	};

	const promotionResourceName = voucher.PromotionInfo?.ResourceName || '';

	const labelReasonMap = {
		[VoucherReasonType.Ranking]: labels?.lbl_RPRankRewards,
		[VoucherReasonType.PeriodSettlement]: labels?.lbl_RPWeeklyVoucher,
		[VoucherReasonType.SignIn]: labels?.lbl_RPCheckInCompleted,
		[VoucherReasonType.Event]: labels?.lbl_giveaway,
		[VoucherReasonType.Purchase]: labels?.lbl_RPSabaShopRedeem,
	};

	// only freebet promotion name is in the promotionResourceName
	const reason = promotionNameReasonTypes.has(voucher.Reason)
		? promotionResourceName
		: labelReasonMap[voucher.Reason];

	return (
		<div className="shop-coupon-record">
			<div className="shop-coupon-record__img">
				<EventVoucherIcon 
					voucherType={voucher.VoucherType}
					isGift={voucherService.isGiftVoucher(voucher)}
					promotionInfo={voucher.PromotionInfo}
				/>
			</div>
			<div className="shop-coupon-record__info">
				<div className="shop-coupon-record__title">
					{voucherService.getVoucherTitle(voucher.VoucherType, labels)}
				</div>
				<div className="shop-coupon-record__text">
					{formatDate(displayDate)}
				</div>
				{
					voucher.Id !== '0' ? (
						<div className="shop-coupon-record__id">ID: {voucher.Id}</div>	
					) : null
				}
			</div>
			<div className="shop-coupon-record__result shop-coupon-record__result--text">
				{isInObtainedTab
					? reason
					: usedStatusLabelMap[usedStatus]
				}
			</div>
		</div>
	);
};